
export default {
  props: {
    value: {
      type: [Boolean, Array],
      default: null,
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    options: {
      type: Array,
      default: null,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    validationMode: {
      type: String,
      default: 'lazy',
    },

    getOptionLabel: {
      type: Function,
      default: (option) =>
        typeof option === 'object' && option.label ? option.label : option,
    },

    getOptionValue: {
      type: Function,
      default: (option) =>
        typeof option === 'object' && option.value ? option.value : option,
    },

    centerLabel: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    instructions: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      innerValue: this.value,
    }
  },

  computed: {
    computedOptions() {
      if (Array.isArray(this.options)) {
        return this.options
      }

      if (this.label) {
        return [
          {
            label: this.label,
            value: this.name,
          },
        ]
      }

      return [this.name]
    },

    hasCustomLabel() {
      return !!this.$slots.label
    },
  },

  watch: {
    innerValue(innerValue) {
      this.$emit('input', innerValue)
    },

    value(value) {
      this.innerValue = value
    },
  },
}
